import { Box, Grid, Typography, Divider, Link } from "@mui/material";
import PageShell from "./PageShell";
import imagen from '../../assets/LOGO MEX CHILE AGCID AMEX 2023 1.svg';
import imagen2 from '../../assets/Inmegen 1.svg';
import imagen3 from '../../assets/agcidChile.svg';
import imagen4 from '../../assets/mexicoChile.svg';
import imagen5 from '../../assets/AMEXID.svg';
import imagen6 from '../../assets/Usach S1.png';
import imagen1 from '../../assets/Salud 1.svg'



export default function Footer({
    year = new Date().getFullYear(),
    logos = [
        { src: imagen3, alt: "Salud" },
        { src: imagen2, alt: "INMEGEN" },
        { src: imagen, alt: "AGCID Chile" },
        { src: imagen4, alt: "México-Chile" },
    ],
    aboutProjectEmail = "acedro@inmegen.gob.mx",
    aboutPlatformEmail = "lgomez@inmegen.gob.mx",
}) {


    const styleImage = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
    }
    return (
        <Box
            component="footer"
            sx={{
                bgcolor: "background.paper",
                color: "text.primary",
                borderTop: "1px solid black",
                mt:10
            }}
        >
            <PageShell>
                <Box sx={{ width: '100%' }}>
                    <Grid container sx={{ width: '100%', mt: 3 }} spacing={3} >
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Box sx={{ width: '100%', textAlign: { xs: "center", md: "left" } }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 400, mb: 1 }} >
                                    This project was funded by AMEXCID
                                </Typography>
                            </Box>
                            <Grid container sx={{ width: '100%', justifyContent: { xs: "center", lg: "flex-start" } }} spacing={2} alignItems="center">
                                <Grid size={{ xs: 6, sm: 4, md: 3, lg: 2.4 }} sx={styleImage}>
                                    <Box
                                        component="img"
                                        src={imagen1}
                                        alt="INMEGEN"
                                        sx={{
                                            height: "auto",
                                            width: "100%",
                                            maxWidth: "157px",
                                            objectFit: "contain",
                                            mt: "-4px",
                                        }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6, sm: 4, md: 3, lg: 2 }} sx={styleImage}>
                                    <Box
                                        component="img"
                                        src={imagen2}
                                        alt="INMEGEN"
                                        sx={{
                                            height: "auto",
                                            width: "100%",
                                            maxWidth: "132px",
                                            objectFit: "contain",
                                            mt: "-4px",
                                        }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.4 }} sx={styleImage}>
                                    <Box
                                        component="img"
                                        src={imagen3}
                                        alt="Salud"
                                        sx={{
                                            height: "auto",
                                            width: "100%",
                                            maxWidth: "92px",
                                            objectFit: "contain",
                                            mt: "-10px",
                                        }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.2 }} sx={styleImage}>
                                    <Box
                                        component="img"
                                        src={imagen4}
                                        alt="México-Chile"
                                        sx={{
                                            height: "auto",
                                            width: "100%",
                                            maxWidth: "73px",
                                            objectFit: "contain",
                                        }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.7 }} sx={styleImage}>
                                    <Box
                                        component="img"
                                        src={imagen5}
                                        alt="AMEXID"
                                        sx={{
                                            height: "auto",
                                            width: "100%",
                                            maxWidth: "114px",
                                            objectFit: "contain",
                                        }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.8 }} sx={styleImage}>
                                    <Box
                                        component="img"
                                        src={imagen6}
                                        alt="Usach"
                                        sx={{
                                            height: "auto",
                                            width: "100%",
                                            maxWidth: "121px",
                                            objectFit: "contain",
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ xs: 12, md: 5 }} sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
                            <Box sx={{ width: '100%', maxWidth: { md: '400px' } }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1, textAlign: { xs: "center", md: "left" } }}>
                                    Contact
                                </Typography>
                                <Grid container sx={{ width: '100%' }} spacing={2}>
                                    <Grid size={{ xs: 12, sm: 6 }} sx={{ ...styleImage, alignItems: { xs: "center", md: "flex-start" } }}>
                                        <Typography variant="body2" color="text.secondary">
                                            About the project
                                        </Typography>
                                        <Link
                                            href={`mailto:${aboutProjectEmail}`}
                                            underline="hover"
                                            variant="body2"
                                        >
                                            {aboutProjectEmail}
                                        </Link>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }} sx={{ ...styleImage, alignItems: { xs: "center", md: "flex-start" } }}>
                                        <Typography variant="body2" color="text.secondary">
                                            About the platform
                                        </Typography>
                                        <Link
                                            href={`mailto:${aboutPlatformEmail}`}
                                            underline="hover"
                                            variant="body2"
                                        >
                                            {aboutPlatformEmail}
                                        </Link>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                    <Divider sx={{ mb: '10px', mt: 2, borderColor: "black" }} />
                    <Grid container sx={{ width: '100%', mb: 2 }} spacing={2} alignItems="center">
                        <Grid size={{ xs: 12, md: 6 }} sx={{ textAlign: { xs: "center", md: "left" } }}>
                            <Typography variant="caption" color="text.secondary">
                                All rights reserved • {year} ©
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Grid container sx={{ width: '100%', justifyContent: { xs: "center", md: "flex-end" } }} spacing={2}>
                                <Grid size="auto">
                                    <Link href="#" underline="hover" variant="caption" color="text.secondary">
                                        Terms of service
                                    </Link>
                                </Grid>
                                <Grid size="auto">
                                    <Link href="#" underline="hover" variant="caption" color="text.secondary">
                                        Privacy Policy
                                    </Link>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </PageShell>
        </Box>
    );
}